import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { of, interval } from 'rxjs';
import {EChannelsActions, GetChannels, GetChannelsSuccess} from '../actions/channels.actions';
import {VideoService} from '../../service/video/video.service';
import {IChannel} from '../../models/channels.interface';

@Injectable()
export class ChannelsEffects {

    getChennels$ = createEffect(() => this._actions$.pipe(
        ofType<GetChannels>(EChannelsActions.GetChannels),
        switchMap((action) => interval(30000).pipe(startWith(0), mapTo(action))),
        switchMap(() => this._videoService.getVideoChannels()),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
        switchMap((next: IChannel[]) => {
            return of(new GetChannelsSuccess(next));
        })
    ));

  constructor(private _videoService: VideoService, private _actions$: Actions) {}
}
